// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.type_enum_f348f146 */
var TypeEnumF348f146;
(function (TypeEnumF348f146) {
    TypeEnumF348f146["Trace"] = "Trace";
    TypeEnumF348f146["Main Components"] = "Main Components";
    TypeEnumF348f146["Nutrient"] = "Nutrient";
})(TypeEnumF348f146 || (TypeEnumF348f146 = {}));
;
export default TypeEnumF348f146;
/** Zod schema for type_enum_f348f146 */
export const typeEnumF348f146 = z.nativeEnum(TypeEnumF348f146);
//# sourceMappingURL=TypeEnumF348f146.js.map